import React, { useState, useRef, useEffect } from 'react';
import { TotpMultiFactorGenerator } from 'firebase/auth';
import './Login.css';
import './MFA.css';

export default function MFAChallenge({ resolver, onAbbrechen }) {
  const [code, setCode]     = useState(['', '', '', '', '', '']);
  const [laden, setLaden]   = useState(false);
  const [fehler, setFehler] = useState(null);
  const inputs = useRef([]);

  useEffect(() => {
    inputs.current[0]?.focus();
  }, []);

  const handleChange = (i, val) => {
    if (!/^\d?$/.test(val)) return;
    const next = [...code];
    next[i] = val;
    setCode(next);
    setFehler(null);
    if (val && i < 5) inputs.current[i + 1]?.focus();
  };

  const handleKeyDown = (i, e) => {
    if (e.key === 'Backspace' && !code[i] && i > 0) {
      inputs.current[i - 1]?.focus();
    }
    if (e.key === 'Enter') onBestaetigen();
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    if (pasted.length === 6) {
      setCode(pasted.split(''));
      inputs.current[5]?.focus();
    }
  };

  const onBestaetigen = async () => {
    const fullCode = code.join('');
    if (fullCode.length < 6) {
      setFehler('Bitte gib den vollständigen 6-stelligen Code ein.');
      return;
    }
    setFehler(null);
    setLaden(true);
    try {
      const totpHint = resolver.hints.find(
        h => h.factorId === TotpMultiFactorGenerator.FACTOR_ID
      );
      const assertion = TotpMultiFactorGenerator.assertionForSignIn(totpHint.uid, fullCode);
      await resolver.resolveSignIn(assertion);
      // onAuthStateChanged in App.js übernimmt die Weiterleitung
    } catch (err) {
      setFehler('Ungültiger Code. Bitte prüfe deine Authenticator-App und versuche es erneut.');
      setCode(['', '', '', '', '', '']);
      setTimeout(() => inputs.current[0]?.focus(), 50);
    } finally {
      setLaden(false);
    }
  };

  return (
    <div className="auth-root">
      <div className="auth-brand">
        <div className="auth-logo">
          <img src="/logo.png" alt="CVFlow" className="auth-logo-mark" />
          <span className="auth-logo-text">CVFlow</span>
        </div>
        <div className="auth-brand-center">
          <h2 className="auth-brand-headline">Sicher.<br />Verifiziert.</h2>
          <p className="auth-brand-sub">
            Zwei-Faktor-Authentifizierung schützt dein Konto — auch wenn dein Passwort kompromittiert wurde.
          </p>
        </div>
        <div className="auth-brand-footer">
          <span>CVFlow © 2025</span>
        </div>
      </div>

      <div className="auth-form-panel">
        <div className="auth-form-inner">
          <div className="mfa-shield-icon">🛡️</div>
          <h1 className="auth-title">Zwei-Faktor-Authentifizierung</h1>
          <p className="auth-subtitle">
            Öffne deine Authenticator-App und gib den aktuellen 6-stelligen Code ein.
          </p>

          <div className="mfa-code-row" onPaste={handlePaste}>
            {code.map((digit, i) => (
              <input
                key={i}
                ref={el => (inputs.current[i] = el)}
                className={`mfa-digit-input${fehler ? ' mfa-digit-error' : ''}`}
                type="text"
                inputMode="numeric"
                maxLength={1}
                value={digit}
                onChange={e => handleChange(i, e.target.value)}
                onKeyDown={e => handleKeyDown(i, e)}
                disabled={laden}
              />
            ))}
          </div>

          {fehler && <div className="auth-error">{fehler}</div>}

          <button
            className="auth-submit"
            onClick={onBestaetigen}
            disabled={laden || code.join('').length < 6}
          >
            {laden ? <span className="auth-spinner" /> : 'Code bestätigen'}
          </button>

          <button
            className="auth-switch-btn"
            onClick={onAbbrechen}
            disabled={laden}
          >
            ← Zurück zur Anmeldung
          </button>
        </div>
      </div>
    </div>
  );
}
